import { createSlice } from '@reduxjs/toolkit';

const importPayrollInitialState = {};
const IP_STORE_KEY = 'importPayroll';

const importPayrollSlice = createSlice({
  name: 'importPayroll',
  initialState: importPayrollInitialState,
  reducers: {},
});

export default importPayrollSlice.reducer;
export { IP_STORE_KEY };
